'use strict';
var IframeLogin;

IframeLogin = window.IframeLogin || {};

IframeLogin.openModal = function(path) {
  var ref, ref1, ref2;
  if (path == null) {
    path = window.location.href;
  }
  this.destination = path;
  GIG.Modal.open({
    el: this.$modal
  });
  return (ref = frames[this.iframeName]) != null ? (ref1 = ref.IframeLogin) != null ? (ref2 = ref1.iframeView) != null ? typeof ref2.resetHeight === "function" ? ref2.resetHeight() : void 0 : void 0 : void 0 : void 0;
};

